import React, { useEffect, useState, useCallback } from 'react';
import { Tooltip as ReactTooltip } from "react-tooltip";
import { useNavigate, useLocation } from "react-router";
import {
    A2AIcon,
    A2AIconNew,
    BookingHistoryIcon,
    CarIcon,
    CarIconMenuNew,
    ChevronDownIcon,
    ChevronRightIcon,
    DashboardIcon,
    ExcursionIcon,
    ExcursionIconNew,
    FlightIcon,
    FlightIconNew,
    FlightNewIcon, FlightSideBarIcon,
    GlobalVisaIcon,
    GlobalVisaIconNew,
    HamburgIcon,
    HotelIconNew,
    HotelVoucherIconNew,
    InsuranceIcon,
    InsuranceIconNew,
    LogoutIcon, LoyaltyPointIcon,
    MoreIcon, NewBookingHistoryIcon,
    NewCarIcon, NewCarIconForMenu,
    NewContactSupportIcon,
    NewExcursionIcon,
    NewFliteIcon,
    NewGlobalVisaIcon,
    NewHotelIcon,
    NewHotelVoucherIcon,
    NewILoyaltyPointsIcon,
    NewInsuranceIcon,
    NewLogoutIcon,
    NewManageStaffIcon,
    NewProfileInfoIcon,
    NewVisaIcon,
    NotificationIcon,
    SupportIcon,
    TelIcon,
    TwoLineIcon,
    UserIcon,
    VoucherIcon,
    WalletIcon
} from '../helper/HwIcon';
import { useDispatch, useSelector } from "react-redux";
import { setAgentActiveCurrency } from "../redux/slice/userSlice";
import CurrencySwitcher from "../component/CurrencySwitcher";
import { agentDefaultImage, formatePriceFn, formatPrice, getUserToken } from "../helper/commonFunction";
import { ApiCall, GetApiCall } from "../helper/axios";
import { useWallet } from '../hooks/useWallet';

function Header() {
    const location = useLocation();
    // Currency switcher: hidden during the checkout / booking / flight-hold
    // steps, but shown again on the confirmed booking view (hotel bookingId or
    // flight bookingReferenceNumber present in the URL).
    const _csPath = location?.pathname || '';
    const _csQuery = new URLSearchParams(location?.search || '');
    const showCurrencySwitcher = !(
        (_csPath.includes('/checkout') || _csPath.startsWith('/flight/booking')) &&
        !((_csPath.includes('/hotels/checkout') && _csQuery.has('bookingId')) ||
            (_csPath.includes('/excursion/checkout') && _csQuery.has('bId')) ||
            (_csPath.startsWith('/flight/booking') && _csQuery.has('bookingReferenceNumber')))
    );
    let navigate = useNavigate();
    const { getBalance, loading: walletLoading } = useWallet()
    const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
    let userToken = getUserToken();
    const { userAgentData, agentActiveCurrency, userNotificationData, walletBalance, agentName, headerMenu, displayPrice } = useSelector((state) => state.userData);

    const dispatch = useDispatch();
    const pathName = location.pathname
    const blockSwitcher = ['/hotels/checkout', '/excursion/checkout', '/flight/booking']?.includes(pathName)

    const fetchWalletBalance = useCallback(async () => {
        try {
            await getBalance();
        } catch (error) {
            console.error('Error fetching wallet balance:', error);
        }
    }, [getBalance]);

    useEffect(() => {
        // Only fetch if user data is available
        if (userAgentData?.user_data?.ID) {
            fetchWalletBalance();
        }
    }, [userAgentData?.user_data?.ID, fetchWalletBalance])

    useEffect(() => {
        if (isSidebarCollapsed) {
            document.body.classList.add('sidebar-collapsed');
        } else {
            document.body.classList.remove('sidebar-collapsed');
        }
    }, [isSidebarCollapsed]);

    const jsToogleSidebarClickFn = () => {
        setIsSidebarCollapsed(prevState => !prevState);
    }

    const userLogoutFn = async () => {
        if (userAgentData?.user_data?.ID) {
            const logoutFromWP = await ApiCall('POST', `wp-json/dahr/v1/user-logout`, {
                user_id: userAgentData?.user_data?.ID,
            }, {}, 'wordpress');
            if (logoutFromWP?.status === 200 && logoutFromWP?.data?.success && logoutFromWP?.data?.redirect_url) {
                window.location.href = logoutFromWP?.data?.redirect_url
            } else {
                alert('Something went wrong')
            }
        } else {
            alert('Something went wrong')
        }
    }

    const dummyVoucherClickFn = async () => {
        if (userToken) {
            const voucherLinkData = await GetApiCall('GET', `wp-json/dahr/v1/get-voucher-link?userToken=${userToken}`, {}, 'wordpress');
            if (voucherLinkData?.status === 200 && voucherLinkData?.data?.url) {
                window.location.href = voucherLinkData?.data?.url
            }
        }
    }

    return (
        <>
            {/* <NotificationIcon />
        <ArrorDownIcon />
        <h1>Header</h1> */}

            <header className={`hw-header${location?.pathname?.startsWith('/excursion') ? ' fixed-top' : ''}`} id='header'>
                <div className='hw-page--width'>
                    <div className='hw-header--wrapper'>
                        <span onClick={jsToogleSidebarClickFn} className="hw-toggle--sidebarBtn">
                            <span className="hw-toggle--hamburg"><span /><span /><span /></span>
                        </span>
                        <div className='hw-header--logo d-flex'>
                            <a className=' d-flex align-items-center' href={process.env.wordpressApiEndPoint}>
                                {/* <img width='162' height='50' src={`${process.env.wordpressApiEndPoint}/wp-content/uploads/2023/08/DAHR-TOURS-Logo.svg`} alt='logo' /> */}
                                <img width='57' height='64' src={`${process.env.wordpressApiEndPoint}/wp-content/uploads/2025/07/logo-new.svg`} alt='logo' />
                            </a>
                        </div>
                        <ul className='hw-main--menu list-unstyled'>
                            {
                                !headerMenu?.['excursion-tickets'] && <li onClick={() => {
                                    setIsSidebarCollapsed(false)
                                    navigate('/excursion/search')
                                }} className={`hw-main--menuItem ${location?.pathname?.startsWith('/excursion') ? 'active' : ''}`}><a className={`hw-main--menuItemLink ${location?.pathname?.startsWith('/excursion') ? 'active' : ''}`} ><i className='hw-main--menuIcon'><ExcursionIconNew /></i><span>Excursions</span></a></li>
                            }


                            {
                                !headerMenu?.['hotel-booking'] && (
                                    <li onClick={() => {
                                        setIsSidebarCollapsed(false)
                                        navigate('/hotels/search')
                                    }} className={`hw-main--menuItem ${location?.pathname?.startsWith('/hotels') ? 'active' : ''}`}><a className={`hw-main--menuItemLink `}><i className='hw-main--menuIcon'><HotelIconNew /></i><span>Hotel</span></a><span class="new-menu--badge">New</span></li>
                                )
                            }

                            {
                                !headerMenu?.['car-transfer'] && (
                                    <li className='hw-main--menuItem'><a href={`${process.env.wordpressApiEndPoint}dashboard/?tab=car-transfer`} className='hw-main--menuItemLink'><i className='hw-main--menuIcon'><CarIconMenuNew /></i><span>Car Transfer</span></a><span className="new-menu--badge">New</span></li>
                                )
                            }
                            {
                                !headerMenu?.['global-visa'] && (
                                    <li className='hw-main--menuItem'><a href={`${process.env.wordpressApiEndPoint}dashboard/?tab=global-visa`} className='hw-main--menuItemLink'><i className='hw-main--menuIcon'><GlobalVisaIconNew /></i><span>Global Visa</span></a></li>
                                )
                            }
                            {
                                !headerMenu?.['insurance'] && (
                                    <li className='hw-main--menuItem'><a href={`${process.env.wordpressApiEndPoint}dashboard/?tab=insurance`} className='hw-main--menuItemLink'><i className='hw-main--menuIcon'><InsuranceIconNew /></i><span>Insurance</span></a></li>
                                )
                            }
                            {!headerMenu?.['flight-booking'] ? <li onClick={() => {
                                setIsSidebarCollapsed(false)
                                navigate('/flight/search')
                            }} className={`hw-main--menuItem  ${location?.pathname?.startsWith('/flight') ? 'active' : ''}`}><a className={`hw-main--menuItemLink`} ><i className='hw-main--menuIcon'><FlightIconNew /></i><span>Flight</span></a></li> : ''}
                            {
                                !headerMenu?.['hotel-dummy-voucher'] && (
                                    <li className='hw-main--menuItem'><a onClick={dummyVoucherClickFn} className='hw-main--menuItemLink'><i className='hw-main--menuIcon'><HotelVoucherIconNew /></i><span>Booking Voucher</span></a></li>
                                )
                            }
                            {
                                !headerMenu?.['visa-change-by-flight'] && (
                                    <li className='hw-main--menuItem'><a href={`${process.env.wordpressApiEndPoint}dashboard/?tab=flight`} className='hw-main--menuItemLink' ><i className='hw-main--menuIcon'><A2AIconNew /></i><span>A2A</span></a></li>
                                )
                            }
                        </ul>


                        <nav className='header-nav'>
                            <ul className='list-unstyled d-flex align-items-center w-100 justify-between ' >
                                {/* <div className='hw-header-line'>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="1" height="40" viewBox="0 0 1 40" fill="none">
                                        <path d="M0.5 0V40" stroke="#CCCCCC" />
                                    </svg>
                                </div> */}
                                <li className='nav-item'></li>
                                <li className='nav-item'></li>
                                {userAgentData?.user_data?.ID ? (
                                    <li className='nav-item'>
                                        <div className='nav-item hw-profile--dropdown dropdown'>
                                            <a className='hw-nav--profile d-flex align-items-center hw-wallet--boxDropdown' data-bs-toggle='dropdown'>
                                                <div className='hw-header--avtar'>
                                                    {
                                                        userAgentData?.user_data?.profile_photo ? <img
                                                            height="40"
                                                            width='40'
                                                            src={userAgentData?.user_data?.profile_photo || agentDefaultImage}
                                                            alt='Profile'
                                                            className='hw-avtar--circle'
                                                            onError={(e) => {
                                                                e.target.src = agentDefaultImage;
                                                            }}
                                                        /> : agentName ?
                                                            <span className='hw-avtar--circle'>{agentName?.toUpperCase()}</span> : <span className='hw-avtar--circle'>{userAgentData?.user_data?.display_name?.[0]?.toUpperCase()}</span>
                                                    }
                                                    <div className='d-flex d-flex-column hw-profile-text'>
                                                        <span className='hw-text14 hw-fontBold hw-blue hw-noWrap d-flex' style={{lineHeight:"2.4rem"}}>
                                                            <div className=' mr-1'>
                                                                {walletLoading ? (
                                                                    <span>Loading...</span>
                                                                ) : (
                                                                        // <> <span className='hw-currency'>AED</span> {walletBalance !== null ? walletBalance : 0.00}</>
                                                                        <>{formatePriceFn(agentActiveCurrency,formatPrice(walletBalance,false,false,true),displayPrice)}</>
                                                                )}
                                                            </div>
                                                            <ChevronDownIcon />
                                                        </span>
                                                        <span className='hw-text12  hw-noWrap' style={{ color: "#555555", fontWeight: 500 }}>
                                                            Wallet Balance
                                                        </span>
                                                    </div>
                                                </div>
                                                {/* <span className=''>{userAgentData?.user_data?.display_name || 'John Deo'}</span><i className='hw-nav--icon hw-icon--chevronDown'></i> */}
                                            </a>

                                            <ul className="dropdown-menu dropdown-menu-start hw-header--dropdownProfile">
                                                <li className='hw-main--menuItem'>
                                                    <a className='hw-main--menuItemLink' href={`${process.env.wordpressApiEndPoint}dashboard/?tab=wallet`}>
                                                        <WalletIcon />
                                                        <span>My Wallet<span className='hw-wallet--amount'>
                                                            {walletLoading ? (
                                                                <span>Loading...</span>
                                                            ) : (
                                                               <span style={{ color: "#3264FF" }}>{formatePriceFn(agentActiveCurrency,formatPrice(walletBalance,false,false,true),displayPrice,true)}</span>
                                                            )}
                                                        </span></span>

                                                    </a>
                                                </li>
                                                <li className='hw-main--menuItem'><a href={`${process.env.wordpressApiEndPoint}dashboard/?tab=bookings-history`} className='hw-main--menuItemLink'><BookingHistoryIcon /><span>Booking History</span></a></li>
                                                {/* <li className='hw-main--menuItem' onClick={() => { navigate('/photo-editor'); }} style={{ cursor: 'pointer' }}>
                                                    <a className='hw-main--menuItemLink'>
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
                                                            <path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z" />
                                                            <circle cx="12" cy="13" r="4" />
                                                        </svg>
                                                        <span>Passport Photo</span>
                                                    </a>
                                                </li> */}
                                                {
                                                    !headerMenu?.['loyalty-points'] && (
                                                        <li className='hw-main--menuItem'><a href={`${process.env.wordpressApiEndPoint}dashboard/?tab=loyalty-points`} className='hw-main--menuItemLink'><NewILoyaltyPointsIcon /><span>Loyalty Points</span></a></li>
                                                    )
                                                }

                                                {userAgentData?.user_data?.roles?.includes('company') ? <li className='hw-main--menuItem'><a href={`${process.env.wordpressApiEndPoint}dashboard/?tab=manage-staff`} className='hw-main--menuItemLink'><NewManageStaffIcon /><span>Manage Staff</span></a></li> : ''}
                                                <li className='hw-main--menuItem'><a href={`${process.env.wordpressApiEndPoint}dashboard/?tab=profile-setting`} className='hw-main--menuItemLink'><NewProfileInfoIcon /><span>My Profile</span></a></li>
                                                <li className='hw-main--menuItem'><a href={`${process.env.wordpressApiEndPoint}dashboard/?tab=my-tickets`} className='hw-main--menuItemLink'><SupportIcon /><span>Support Ticket</span></a></li>
                                                <li className='hw-main--menuItem'><a href={`${process.env.wordpressApiEndPoint}dashboard/?tab=customer-support`} className='hw-main--menuItemLink'><NewContactSupportIcon /><span>Contact Support</span></a></li>
                                                <li onClick={userLogoutFn} style={{ cursor: "pointer" }} className='hw-main--menuItem'><a className='hw-main--menuItemLink'><NewLogoutIcon /><span>Logout</span></a></li>
                                            </ul>


                                        </div>

                                    </li>
                                ) : <li className='nav-item'>
                                    <div className='nav-item hw-profile--dropdown dropdown'>
                                        <a className='hw-nav--profile d-flex align-items-center hw-wallet--boxDropdown' data-bs-toggle='dropdown'>
                                            <div className='hw-header--avtar'>
                                                <img
                                                    height="38"
                                                    width='38'
                                                    src={agentDefaultImage}
                                                    alt='Profile'
                                                    className='hw-avtar--circle'
                                                    onError={(e) => {
                                                        e.target.src = agentDefaultImage;
                                                    }}
                                                />
                                                <span className='hw-text14 hw-fontBold hw-blue'>
                                                    <span>Loading...</span>
                                                </span>
                                            </div>
                                            <ChevronDownIcon />
                                        </a></div>
                                </li>
                                }
                                {true /* show switcher on checkout too */ && (
                                    <li className='nav-item hw-currency-switch-li'>
                                        <CurrencySwitcher />
                                    </li>
                                )}
                            </ul>
                        </nav>
                    </div>
                </div>
            </header>

        </>
    );
}

export default Header;